import { clsx } from 'clsx';
import { type ComponentPropsWithRef } from 'react';
import { borderRadius } from '../tokens';
import { skeletonV2 } from './skeleton-v2.css.ts';

export const SkeletonV2 = ({
  ref,
  className,
  height = 12,
  width = 80,
  radius = borderRadius.r16,
  ...rest
}: ComponentPropsWithRef<'div'> & {
  height?: number | string;
  width?: number | string;
  radius?: number;
}) => (
  <div
    ref={ref}
    style={{ height, width, borderRadius: radius }}
    className={clsx(skeletonV2, className)}
    {...rest}
    data-testid="skeleton-v2"
  />
);
